import React from 'react';
import styles from './DocumentHr.module.scss';

const DocumentHr = () => (
    <hr className={styles.DocumentHr} />
);

export default DocumentHr;
